export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "clientstatus.worker.e7388183ddbfe8efe17a.worker.js");
}
